"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionPolygonCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const PositionCardTemplate_1 = require("./PositionCardTemplate");
const PositionPolygonCard = ({ objectType, mode, version, title, name }) => {
    const [geometryPoints, , geometryHelpersPoints] = (0, formik_1.useField)({
        name: name ?? "geometry",
    });
    const handlePolygonSelection = (points) => {
        geometryHelpersPoints.setValue(points ?? [[]]);
    };
    return ((0, jsx_runtime_1.jsx)(PositionCardTemplate_1.PositionCardTemplate, { mode: mode, version: version, title: title, position: {
            objectType,
            geometryPoints: geometryPoints.value
        }, onPositionSelection: (pos) => {
            handlePolygonSelection(pos.geometryPoints);
        }, selectDialogTitle: objectType === 'linie' ?
            'Zvolte v mapě linii, která odpovídá objektu' :
            'Označte v mapě body, které vymezují prostor objektu' }));
};
exports.PositionPolygonCard = PositionPolygonCard;
